import { ExternalLink } from 'lucide-react';

export const PostPayPromoCard = () => (
  <article
    className="group relative h-full overflow-hidden border border-yellow-900/50 bg-[#0f0f10] shadow-lg shadow-black/40 transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1 hover:border-yellow-500/80 hover:shadow-red-950/30"
    data-testid="postpay-promo-card"
  >
    <a
      href="https://www.postpay.stream"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Promotional link to PostPay Stream"
      className="block h-full focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-500"
      data-testid="postpay-external-link"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-black">
        <img
          src="/postpay-promo.png"
          alt="PostPay — get paid to post and turn your views into money"
          className="h-full w-full object-contain transition-transform duration-500 group-hover:scale-[1.03]"
          loading="lazy"
          data-testid="postpay-thumbnail-img"
        />
        <span className="absolute right-1 top-1 border border-yellow-700/70 bg-black/85 px-1 py-0.5 text-[7px] font-bold uppercase text-yellow-300 sm:right-2 sm:top-2 sm:px-2 sm:py-1 sm:text-[9px]">
          Sponsored
        </span>
        <span className="absolute bottom-1 right-1 inline-flex items-center gap-0.5 bg-yellow-600 px-1.5 py-1 text-[7px] font-bold uppercase text-white transition-colors group-hover:bg-yellow-500 sm:bottom-2 sm:right-2 sm:gap-1 sm:px-2.5 sm:py-1.5 sm:text-[10px]">
          PostPay <ExternalLink size={9} />
        </span>
      </div>
    </a>
  </article>
);